import AdminMainButton from "./AdminMainButton";

export default AdminMainButton;
